import { useState } from "react"
import type { FC } from "react"

import styles from "./BulkApplyBar.module.scss"

import CheckboxCheckedIcon from "@/lib/images/CheckboxCheckedIcon"
import SaveButton from "@/souhl_admin/components/ui/SaveButton/SaveButton"
import type {
	DataSourcePolicy,
	DataSourcePolicyWithText,
} from "@/souhl_admin/gql/__generated__/graphql"

type BulkApplyBarProps = {
	selectedCount: number
	policyOptions: readonly DataSourcePolicyWithText[]
	onApply: (goalPolicy: DataSourcePolicy | null) => Promise<void>
	loading: boolean
}

const CLEAR_VALUE = "__CLEAR__"

const BulkApplyBar: FC<BulkApplyBarProps> = ({
	selectedCount,
	policyOptions,
	onApply,
	loading,
}) => {
	const [selectedValue, setSelectedValue] = useState("")

	const handleApply = () => {
		if (!selectedValue) return

		const goalPolicy =
			selectedValue === CLEAR_VALUE
				? null
				: (policyOptions.find((opt) => opt.value === selectedValue)?.value ??
					null)

		onApply(goalPolicy)
			.then(() => {
				setSelectedValue("")
			})
			.catch(() => {
				// エラーは useDatasourceConfig 側で処理済み
			})
	}

	return (
		<div className={styles.bar}>
			<span className={styles.badge}>
				<CheckboxCheckedIcon />
				{selectedCount}件選択中
			</span>
			<label className={styles.selectLabel}>目標の媒体設定:</label>
			<select
				className={styles.select}
				value={selectedValue}
				onChange={(e) => setSelectedValue(e.target.value)}
				disabled={loading}
			>
				<option value="" disabled>
					選択してください
				</option>
				{policyOptions.map((opt) => (
					<option key={opt.value} value={opt.value}>
						{opt.label}
					</option>
				))}
				<option value={CLEAR_VALUE}>クリア（目標をリセット）</option>
			</select>
			<SaveButton
				onClick={handleApply}
				disabled={!selectedValue}
				loading={loading}
			/>
		</div>
	)
}

export default BulkApplyBar
